// Define IG
window.igEvents = window.igEvents || [];

// Cart Drawer Events
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');

  if (cartDrawer) {
    // Cart Drawer clicked and is opening
    cartDrawer.addEventListener('dialog:before-show', (e) => {
       window.igEvents.push({"event": "CartDrawerOpened"});  
      console.log('Cart Drawer öffnet sich (before-show).', e);
    });

    // Cart Drawer Opened
    cartDrawer.addEventListener('dialog:after-show', (e) => {
      console.log('Cart Drawer wurde geöffnet (after-show).', e);
    });
  }

  // General fallback: if other scripts only temporarily replace the drawer element, listen at the document level and check whether a drawer is visible.
  document.addEventListener('dialog:after-show', (e) => {
    // e.detail.activator is the trigger
    const target = e.target;
    if (target && (target.matches && target.matches('cart-drawer') || target.tagName?.toLowerCase() === 'cart-drawer')) {
      console.log('Cart Drawer document: cart-drawer after show (document dialog:after-show)', target);
      // Fallback code here
    }
  });
});